import React from "react";
import GenericMasterPage from "@/pages/GenericMasterPage";

export default function InstallationTypesPage() {
  return (
    <GenericMasterPage
      resourcePath="installation-types"
      testIdPrefix="installation-type"
      title="Installation Type"
      description="Installation categories — used as a multi-select on each vehicle."
      fields={[{ key: "name", label: "Installation Type", required: true, placeholder: "e.g. Basic, Fuel, Relay" }]}
      displayKeys={["name"]}
    />
  );
}
